import { G as a, E as g, I as i, _ as r, D as s } from "./index-DI9h0G2c.js";
export {
  a as GenerateSecureID,
  g as H,
  i as HighlightSegmentMiddleware,
  r as __testing,
  s as configureElectronHighlight
};
//# sourceMappingURL=index.js.map
